import storage from 'utils/storage'
import startSegment from './init'

const stepsName = [
  'Group_selection',
  'Payment_and_due_date',
  'Deal_finished',
  'Deal_information',
  'Deal_details',
]

const snippets = {
  pageView: ({ name: pageName, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.page(pageName, {
          currentPath: window.location.pathname,
          currentUrl: window.location.href,
          analyticsUuid: analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('pageView_error', error)
      })
  },

  Button_Click: (myParams) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Button_Click', myParams)
      })
      .catch((error) => {
        console.error('button_click_error', error)
      })
  },

  track_whatsapp: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Send_bank_slip_whatsapp', {
          leadType,
          analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('deal_started_error', error)
      })
  },

  track_download_bank_slip: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Download_bank_slip', {
          leadType,
          analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('deal_started_error', error)
      })
  },

  track_copy_bar_code: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Copy_bar_code', { leadType, analyticsUuid })
      })
      .catch((error) => {
        console.error('deal_started_error', error)
      })
  },

  whats_app_journey_start: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('whats_app_journey_start', {
          leadType,
          analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('whats_app_journey_start_error', error)
      })
  },

  Deal_started: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Deal_started', { leadType, analyticsUuid })
      })
      .catch((error) => {
        console.error('deal_started_error', error)
      })
  },

  Deal_finished: (myParams) => {
    return startSegment()
      .then(() => {
        window.analytics.track('Deal_finished', myParams)
      })
      .catch((error) => {
        console.error('deal_finished_error', error)
      })
  },

  Debt_groups: ({ stepIndex, groups, leadType, analyticsUuid }) => {
    const newGroups = groups.map((group, index) => ({
      ...group,
      group_position: index + 1,
    }))

    return startSegment()
      .then(() =>
        window.analytics.page('Debt_groups', {
          step: stepsName[stepIndex] + 1,
          groups_impressions: newGroups,
          leadType,
          analyticsUuid,
        })
      )
      .catch((error) => {
        console.error('debt_groups_error', error)
      })
  },

  group_cancelled: ({ stepIndex, group, index, leadType, analyticsUuid }) => {
    return startSegment()
      .then(() =>
        window.analytics.page('group_cancelled', {
          step: stepsName[stepIndex] + 1,
          group_cancelled: { ...group, group_position: index + 1 },
          leadType,
          analyticsUuid,
        })
      )
      .catch((error) => {
        console.error('group_cancelled_error', error)
      })
  },

  document_registration: ({ leadType, analyticsUuid }) => {
    return startSegment()
      .then(() => {
        window.analytics.track('document_registration', {
          leadType,
          analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('document_registration_error', error)
      })
  },

  registration_completed: ({ leadType, analyticsUuid }) => {
    return new Promise((resolve, reject) => {
      return startSegment()
        .then(() => {
          window.analytics.track(
            'registration_completed',
            { leadType, analyticsUuid },
            resolve
          )
        })
        .catch((error) => {
          console.error('registration_error', error)
          reject()
        })
    })
  },

  lp_registration_alert: (myParams) => {
    return new Promise((resolve, reject) => {
      return startSegment()
        .then(() => {
          window.analytics.track('lp_registration_alert', myParams, resolve)
        })
        .catch((error) => {
          console.error('lp_registration_alert_error', error)
          reject()
        })
    })
  },

  code_copy_button: ({ leadType, analyticsUuid, tracking }) => {
    return startSegment()
      .then(() => {
        window.analytics.track(tracking, {
          leadType,
          analyticsUuid,
        })
      })
      .catch((error) => {
        console.error('code_copy_button', error)
      })
  },
}

const track = (fnName, trackParams = {}) => {
  const fn = snippets[fnName]

  const leadType = storage.session.getItem('leadType')
  const analyticsUuid = storage.session.getItem('analyticsUuid')

  const newTrackParams = {
    ...(typeof trackParams === 'string' ? { name: trackParams } : trackParams),
    ...(leadType ? { leadType } : {}),
    analyticsUuid: analyticsUuid,
  }

  if (!fn) {
    console.error(new Error(`${fnName} doesn't exist`))
    return
  }

  return fn(newTrackParams)
    .then(console.log(`[ Segment ${fnName} ] -`, newTrackParams || ''))
    .catch((error) => {
      console.error(`Segment ${fnName} error -`, error)
    })
}

export default track
